import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PortWeatherService {
  // Using the absolute URL provided by the user
  private readonly baseUrl: string = 'https://portweather.merakishippingservices.com';

  constructor(private http: HttpClient) {}

  getPortDetails(): Observable<any> {
    const url = `${this.baseUrl}/port_details`;
    return this.http.get<any>(url).pipe(catchError(this.errorHandler));
  }

  submitDetails(body: any): Observable<any> {
    const url = `${this.baseUrl}/port_weather/generate_report`;
    return this.http
      .post(url, body, { responseType: 'text' })
      .pipe(catchError(this.errorHandler));
  }

  getTableData(): Observable<any> {
    const url = `${this.baseUrl}/port_weather/retrieve_reports`;
    return this.http.get<any>(url).pipe(catchError(this.errorHandler));
  }

  getPdf(filename: string): Observable<any> {
    // API: https://portweather.merakishippingservices.com/port_weather/downloadpdf?pdffilename=<filename>
    const url = `${this.baseUrl}/port_weather/downloadpdf?pdffilename=${filename}`;
    return this.http.get(url, { responseType: 'blob' }).pipe(
      catchError(this.errorHandler)
    );
  }

  downloadReport(body: any): Observable<any> {
    const url = `${this.baseUrl}/port_weather/download_report`;
    return this.http.post(url, body).pipe(catchError(this.errorHandler));
  }

  private errorHandler(error: HttpErrorResponse) {
    return throwError(() => error || 'Server Error');
  }
}
